import axios from 'axios';
import { AnyAction, combineReducers } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import config from 'config';
import { ChatThread } from 'models/chat';
import { createAction } from 'ducks/actionHelpers';
import { loadNonReservationToken } from './tracking';

const FETCH_CHAT_THREADS_REQUEST = 'FETCH_CHAT_THREADS_REQUEST';
const FETCH_CHAT_THREADS_SUCCESS = 'FETCH_CHAT_THREADS_SUCCESS';
const FETCH_CHAT_THREADS_FAILURE = 'FETCH_CHAT_THREADS_FAILURE';

// Action creators

const fetchChatThreadsRequest = () => createAction(FETCH_CHAT_THREADS_REQUEST);
const fetchChatThreadsSuccess = (payload: { chat_threads: ChatThread[] }) =>
  createAction(FETCH_CHAT_THREADS_SUCCESS, payload);
const fetchChatThreadsFailure = (payload: string) =>
  createAction(FETCH_CHAT_THREADS_FAILURE, payload);

export const fetchChatThreads = (apiKey: string, contentLanguage: string) => (
  dispatch: ThunkDispatch<Record<string, unknown>, Record<string, unknown>, AnyAction>
): Promise<void> => {
  const trackingId = loadNonReservationToken();

  dispatch(fetchChatThreadsRequest());
  return axios
    .get(`${config.apiUrl}/chatthreads`, {
      headers: {
        'x-api-key': apiKey,
        'accept-language': contentLanguage,
        'x-track-id': trackingId,
      },
    })
    .then((response) => {
      dispatch(fetchChatThreadsSuccess(response.data));
    })
    .catch((err) => {
      dispatch(fetchChatThreadsFailure(err.message));
    });
};

type Action =
  | ReturnType<typeof fetchChatThreadsRequest>
  | ReturnType<typeof fetchChatThreadsSuccess>
  | ReturnType<typeof fetchChatThreadsFailure>;

// Reducers
const error = (state = '', action: Action) => {
  switch (action.type) {
    case FETCH_CHAT_THREADS_FAILURE:
      return action.payload;
    case FETCH_CHAT_THREADS_REQUEST:
    case FETCH_CHAT_THREADS_SUCCESS:
      return '';
    default:
      return state;
  }
};

const loading = (state = false, action: Action) => {
  switch (action.type) {
    case FETCH_CHAT_THREADS_REQUEST:
      return true;
    case FETCH_CHAT_THREADS_SUCCESS:
    case FETCH_CHAT_THREADS_FAILURE:
      return false;
    default:
      return state;
  }
};

const all = (state: ChatThread[] = [], action: Action) => {
  switch (action.type) {
    case FETCH_CHAT_THREADS_SUCCESS:
      return action.payload.chat_threads || [];
    default:
      return state;
  }
};

export interface ChatThreadsState {
  error: ReturnType<typeof error>;
  all: ReturnType<typeof all>;
}

export default combineReducers({
  error,
  loading,
  all,
});
